import React from 'react';
import { useLocation } from 'react-router-dom';

import Sidebar from '../../components/Navigation/Sidebar';
import Topbar from '../../components/Navigation/Topbar';
import PropTypes from "prop-types";

export default function Layout({ children }) {
    const location = useLocation();
    const isSalesPage = location.pathname === '/sales';
    
    return (
        <div>
            <div id="wrapper" className={isSalesPage ? 'no-sidebar' : ''}>
                {!isSalesPage && <Sidebar />}
                <div id="content-wrapper" className="d-flex flex-column" style={isSalesPage ? { marginLeft: 0, width: '100%' } : {}}>
                    <div id="content">
                        <Topbar/>
                        <div className="container-fluid">
                            { children }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

Layout.propTypes = {
    children: PropTypes.element.isRequired,
};